export default __webpack_public_path__ + "static/media/template.06db6845.svg";